<template>
    <a href="javascript:void(0)" v-on:click="openUrl()" :class="getTooltipClass()" :tooltip="getTooltip()" flow="down">
        <img :src="image">
    </a>
</template>

<script>

    import {common} from '@mixins/common';

    export default {
        name: "HkepThumbnail",
        mixins:[common],
        data() {
            return {
                is_demo_user: is_demo_user
            }
        },
        props: {
            url: {
                default: "",
                type: String
            },
            image: {
                default: "",
                type: String
            },
            item: {
                default: {}
            }
        },
        mounted() {
        },
        methods: {
            openUrl()
            {
                if (is_demo_user && !this.item.allow_download) {

                } else {
                    if (this.url) {
                        window.open(this.url, "_blank");
                    }

                }
            },
            getTooltipClass()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return "demo-thumbnail dark thumbnail-a";
                }

                return "dark thumbnail-a";
            },
            getTooltip()
            {
                if (is_demo_user && !this.item.allow_download) {
                    return this.lang(this.$t('Authorization required download')).toLowerCase();
                }
                return "";
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/HkepThumbnail.vue